/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { initialState } from './defaultState';
import { setOpenModal } from './actions';

const modalsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setOpenModal, (state, action) => {
      state[action.payload.modal] = action.payload.isOpen;
    });
});

export default modalsReducer;
